var _rect, _rect2, _path, _rect3, _rect4, _path2, _rect5, _rect6, _g, _g2, _g3, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRentalsEmpty(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 204,
    height: 90,
    fill: "none",
    viewBox: "0 0 204 90",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 136,
    height: 40,
    x: 10,
    y: 2,
    fill: "#fff",
    rx: 8
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    x: 18,
    y: 10,
    fill: "#F7685B",
    opacity: 0.2,
    rx: 4
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#F7685B",
    d: "M36.429 16.286h-3.65c-.995.016-1.972.26-2.857.714l-.443.221c-.703.34-1.477.51-2.257.493h-3.65c-.19 0-.371.076-.505.21-.134.133-.21.315-.21.505V27c0 .19.076.371.21.505s.315.21.505.21h3.65c.991-.006 1.969-.238 2.857-.68l.443-.22c.7-.353 1.473-.534 2.257-.53h3.65c.19 0 .371-.075.505-.209s.21-.315.21-.505V17c0-.19-.076-.371-.21-.505s-.316-.21-.505-.21zm-.714 6.428c-.569 0-1.114.226-1.516.628-.401.402-.627.947-.627 1.515h-.793c-.992.006-1.97.238-2.857.679l-.443.221c-.701.35-1.474.53-2.257.529h-.793c0-.569-.226-1.114-.628-1.516-.402-.401-.947-.627-1.515-.627v-2.857c.568 0 1.113-.226 1.515-.628.402-.402.628-.947.628-1.515h.793c.994-.017 1.972-.261 2.857-.714l.443-.222c.704-.337 1.477-.505 2.257-.493h.793c0 .569.225 1.114.627 1.516.402.401.947.627 1.516.627v2.857zM32.143 22c0 .424-.126.838-.361 1.19-.235.353-.57.627-.962.79-.391.162-.822.204-1.238.122-.415-.083-.797-.287-1.097-.587-.3-.3-.504-.681-.586-1.097-.083-.416-.04-.846.121-1.238.163-.392.437-.726.79-.962.352-.235.767-.36 1.19-.36.569 0 1.114.225 1.515.627.402.402.628.947.628 1.515z"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 136,
    height: 40,
    x: 42,
    y: 50,
    fill: "#fff",
    rx: 8
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    x: 50,
    y: 58,
    fill: "#2ED47A",
    opacity: 0.2,
    rx: 4
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#2ED47A",
    d: "M59.856 68.572c1.577 0 2.856-1.28 2.856-2.858s-1.279-2.857-2.856-2.857S57 64.137 57 65.714c0 1.578 1.279 2.858 2.856 2.858zm0-4.286c.789 0 1.428.64 1.428 1.428 0 .79-.64 1.429-1.428 1.429-.789 0-1.428-.64-1.428-1.429s.64-1.428 1.428-1.428zm4.82 7.443l.892-.893v-2.264c0-.395-.32-.715-.714-.715-.394 0-.714.32-.714.715v2.5c.23.172.413.397.536.657zm3.57-1.522c-.134-.135-.317-.211-.507-.211s-.373.076-.507.211l-2.378 2.357c-.034.961-.824 1.722-1.785 1.722h-2.856c-.197 0-.357-.16-.357-.357 0-.198.16-.358.357-.358h3.02c.572-.08.975-.604.907-1.178-.08-.566-.572-.98-1.142-.964h-3.35c-.68-.06-1.355.176-1.848.65l-2.021 2.078c-.277.279-.277.729 0 1.007l1.77 1.772c.28.277.729.277 1.008 0l1.013-1.015c.133-.132.313-.206.5-.207h2.913c.474 0 .928-.187 1.264-.521l3.97-3.971c.135-.135.211-.317.211-.508 0-.19-.076-.373-.21-.507h.028z"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 8,
    x: 50,
    y: 18,
    fill: "#C2CFE0",
    rx: 2
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 8,
    x: 82,
    y: 66,
    fill: "#C2CFE0",
    rx: 2
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    x: 2,
    y: 50,
    fill: "#fff",
    rx: 8
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4494FF",
    d: "M23.834 65.583v.834c0 .23-.187.416-.417.416h-4.583v4.584c0 .23-.187.416-.417.416h-.833c-.23 0-.417-.186-.417-.416v-4.584h-4.583c-.23 0-.417-.186-.417-.416v-.834c0-.23.187-.416.417-.416h4.583v-4.584c0-.23.186-.416.417-.416h.833c.23 0 .417.186.417.416v4.584h4.583c.23 0 .417.186.417.416z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f)",
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    x: 162,
    y: 2,
    fill: "#fff",
    rx: 6
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4494FF",
    d: "M178.375 13.688v.624c0 .173-.14.313-.313.313h-3.437v3.438c0 .172-.14.312-.313.312h-.624c-.173 0-.313-.14-.313-.313v-3.437h-3.437c-.173 0-.313-.14-.313-.313v-.624c0-.173.14-.313.313-.313h3.437V9.937c0-.172.14-.312.313-.312h.624c.173 0 .313.14.313.313v3.437h3.437c.173 0 .313.14.313.313z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_f)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    x: 186,
    y: 50,
    fill: "#fff",
    rx: 4
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4494FF",
    d: "M196.916 57.792v.416c0 .115-.093.209-.208.209h-2.292v2.291c0 .115-.093.209-.208.209h-.417c-.115 0-.208-.094-.208-.209v-2.291h-2.292c-.115 0-.208-.094-.208-.209v-.416c0-.115.093-.209.208-.209h2.292v-2.291c0-.115.093-.209.208-.209h.417c.115 0 .208.094.208.209v2.291h2.292c.115 0 .208.094.208.209z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f",
    width: 36,
    height: 36,
    x: 0,
    y: 48,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "effect1_foregroundBlur",
    stdDeviation: 1
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f",
    width: 28,
    height: 28,
    x: 160,
    y: 0,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "effect1_foregroundBlur",
    stdDeviation: 1
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_f",
    width: 20,
    height: 20,
    x: 184,
    y: 48,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "effect1_foregroundBlur",
    stdDeviation: 1
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRentalsEmpty);
export default __webpack_public_path__ + "static/media/rentals-empty.97814fed.svg";
export { ForwardRef as ReactComponent };